<template>
    <div class="pagination">
        <base-button background="var(--white-color)"
                     @click="changeTo(-1)"
                     class="mr-8 max-left-btn">
            <svg width="9px" height="14px" fill="#000">
                <use xlink:href="../../assets/images/sprite.svg#angle"></use>
            </svg>
            <svg width="9px" height="14px" fill="#000">
                <use xlink:href="../../assets/images/sprite.svg#angle"></use>
            </svg>
        </base-button>
        <base-button background="var(--white-color)"
                     @click="changeTo(0)"
                     class="mr-8 left-btn">
            <svg width="9px" height="14px" fill="#000">
                <use xlink:href="../../assets/images/sprite.svg#angle"></use>
            </svg>
        </base-button>
        <base-button v-for="(item, key) in length"
                     :key="key"
                     :background="currentPage === item ? 'var(--primary-color)' : 'var(--white-color)'"
                     :color="currentPage === item ? 'var(--white-color)' : '#000'"
                     @click="change(item)"
                     class="mr-8 page-btn">{{item}}</base-button>
        <base-button @click="changeTo(1)"
                     background="var(--white-color)"
                     class="mr-8 right-btn">
            <svg width="9px" height="14px" fill="#000" style="transform: rotate(180deg)">
                <use xlink:href="../../assets/images/sprite.svg#angle"></use>
            </svg>
        </base-button>
        <base-button @click="changeTo(2)"
                     background="var(--white-color)"
                     class="max-right-btn">
            <svg width="9px" height="14px" fill="#000" style="transform: rotate(180deg)">
                <use xlink:href="../../assets/images/sprite.svg#angle"></use>
            </svg>
            <svg width="9px" height="14px" fill="#000" style="transform: rotate(180deg)">
                <use xlink:href="../../assets/images/sprite.svg#angle"></use>
            </svg>
        </base-button>
    </div>
</template>

<script>
    export default {
        name: "pagination",
        data() {
            return {
                currentPage: 1
            }
        },
        props: {
            length: {
                type: Number,
                default: 1
            },
            current: {
                type: Number,
                default: 1
            }
        },
        mounted() {
            this.currentPage = this.current;
        },
        methods: {
            change(item) {
                if (this.currentPage === item) {
                    return
                }
                this.currentPage = item;
                this.$emit("change", this.currentPage)
            },
            changeTo(to) {
                if (to === 1) {
                    if (this.currentPage < this.length) {
                        this.currentPage++;
                        this.$emit("change", this.currentPage);
                    }
                } else if(to === 0) {
                    if (this.currentPage > 1) {
                        this.currentPage--;
                        this.$emit("change", this.currentPage);
                    }
                } else if(to === -1) {
                    this.currentPage = 1;
                    this.$emit("change", this.currentPage);
                } else if (to === 2) {
                    this.currentPage = this.length;
                    this.$emit("change", this.currentPage);
                }
            }
        },
        watch: {
            current(val) {
                this.currentPage = val
            }
        }
    }
</script>

<style scoped>
    .pagination {
        display: flex;
        justify-content: center;
    }
    .pagination .base-button {
        width: 39px;
    }
</style>
